import {LanguageSwitcherItemLabelDefaultBox} from "./language-switcher-item-label.default.box";

export const LanguageSwitcherItemLabelBox = LanguageSwitcherItemLabelDefaultBox;
